import Axios from 'axios'

// initial state
const state = {
  headerCaption: 'Your order',
  showOrderTotal: false,
  imageAssetUrl: window.imageAssetUrl,
  seratoLogo: window.imageAssetUrl + '/logos/serato-logo-white.svg',
  paymentsAssetUrl: {
    'visa': window.imageAssetUrl + '/checkout/visa.svg',
    'mastercard': window.imageAssetUrl + '/checkout/mastercard.svg',
    'paypal': window.imageAssetUrl + '/checkout/paypal.svg'
  },
  paymentGatewayInfo: {},
  inAppPurchase: window.inAppPurchase,
  referrerUrl: window.referrerUrl,
  redirectUrl: window.redirectUrl,
  infoMessage: '',
  errorMessage: '',
  gtmCheckoutName: window.gtmCheckoutName,
  gtmSent: false,
  loadingStack: [],
  taxChangeLoading: false,
  geoIpContinent: window.geoIpContinent,
  changeUserUrl: window.changeUserUrl,
  loginUrl: window.loginUrl
}

const actions = {
  updateShowOrderTotal ({ commit }, newState) {
    commit('updateShowOrderTotal', newState)
  },
  updateHeaderCaption ({ commit }, newState) {
    commit('updateHeaderCaption', newState)
  },
  updateImageAssetUrl ({ commit }, newState) {
    commit('updateImageAssetUrl', newState)
  },
  fetch ({ commit }) {
    Axios.get('/payment/info')
    .then((response) => {
      commit('updatePaymentGatewayInfo', response.data)
    })
    .catch((error) => {
      console.error(error)
    })
  },
  error ({ commit }, msg) {
    commit('errorMessage', msg)
  },
  info ({ commit }, msg) {
    commit('infoMessage', msg)
  },
  clearMessages ({ commit }) {
    commit('clearMessages')
  },
  setGtmSentFlag ({ commit }) {
    commit('setGtmSentFlag')
  },
  setTaxChangeLoading ({ commit }) {
    commit('setTaxChangeLoading')
  },
  unsetTaxChangeLoading ({ commit }) {
    commit('unsetTaxChangeLoading')
  },
  addToLoading ({ commit }, itemToAdd) {
    commit('addToLoading', itemToAdd)
  },
  removeFromLoading ({ commit }, itemToRemove) {
    commit('removeFromLoading', itemToRemove)
  },
  clearLoading ({ commit }) {
    commit('clearLoading')
  },
  removePaymentGatewayInfo ({ commit }) {
    commit('clearPaymentGatewayInfo')
  }
}

const mutations = {
  updateShowOrderTotal (state, newState) {
    state.showOrderTotal = newState
  },
  updateHeaderCaption (state, newState) {
    state.headerCaption = newState
  },
  updateImageAssetUrl (state, newState) {
    state.imageAssetUrl = newState
  },
  updatePaymentGatewayInfo (state, newState) {
    state.paymentGatewayInfo = newState
  },
  errorMessage (state, newState) {
    state.errorMessage = newState.error
    state.infoMessage = ''
  },
  infoMessage (state, newState) {
    state.infoMessage = newState
    state.errorMessage = ''
  },
  clearMessages (state) {
    state.errorMessage = ''
    state.infoMessage = ''
  },
  clear (state) {
    Object.keys(state).forEach((key) => {
      state[key] = null
    })
  },
  setGtmSentFlag (state) {
    state.gtmSent = true
  },
  setTaxChangeLoading (state) {
    state.taxChangeLoading = true
  },
  unsetTaxChangeLoading (state) {
    state.taxChangeLoading = false
  },
  addToLoading (state, itemToAdd) {
    state.loadingStack.push(itemToAdd)
  },
  removeFromLoading (state, itemToRemove) {
    // The logic below should work with all browsers
    for (var i = state.loadingStack.length - 1; i >= 0; i--) {
      if (state.loadingStack[i] === itemToRemove) {
        state.loadingStack.splice(i, 1)
        break
      }
    }
  },
  clearLoading (state) {
    state.loadingStack = []
    state.taxChangeLoading = false
  },
  clearPaymentGatewayInfo (state) {
    state.paymentGatewayInfo = {}
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./vue/checkout/store/modules/global.js